export * from "./award.model";
export * from "./download.model";
export * from "./filter.model";
export * from "./header.model";
export * from "./highlight.model";
export * from "./image-effect.model";
export * from "./image-with-effects.model";
export * from "./image-with-hot-points.model";
export * from "./hot-point.model";
export * from "./images.model";
export * from "./photo-for-list.model";
export * from "./gallery-item.model";
export * from "./spec.model";
export * from "./sub-spec.model";
export * from "./videos.model";
export * from "./video.model";
export * from "./software.model";
export * from "./software-slide.model";
export * from "./wheretobuy.model";



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/index.ts